import apiClient from '@src/api/clients';

const BASE_URL = 'tasks/onboarding-tasks/';

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
  );

export const listOnboardingTasks = (params = {}) =>
  apiClient.request({ url: BASE_URL, method: 'GET', payload: cleanParams(params) });

export const updateOnboardingTask = (taskId, payload) =>
  apiClient.request({ url: `${BASE_URL}${taskId}/`, method: 'PATCH', payload });

export default {
  listOnboardingTasks,
  updateOnboardingTask,
};
